/**
 * Host platform detection. Used to gate the mobile-only email "save mode": on
 * iOS/Android there is no drag-drop, so saving an open email is done by browsing
 * to a folder and tapping Save here. Desktop/web keep drag-drop and never show it.
 */

/** True for Outlook on iOS or Android. Pure (takes the platform value) for testing. */
export function isMobilePlatform(platform: string | null | undefined): boolean {
  if (!platform) return false;
  const p = String(platform).toLowerCase();
  return p === 'ios' || p === 'android';
}

/** Read the live Office host platform; false outside Office (dev/harness). */
export function detectMobile(): boolean {
  try {
    return isMobilePlatform(Office?.context?.platform as unknown as string);
  } catch {
    return false;
  }
}
